"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tab;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("../Tabset/context");

var _container = _interopRequireDefault(require("./styled/container"));

var _truncatedText = _interopRequireDefault(require("../Structural/truncatedText"));

var _button = _interopRequireDefault(require("./styled/button"));
/* eslint-disable no-script-url, react/prop-types */


var TabItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TabItem, _Component);

  function TabItem(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TabItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TabItem).call(this, props));
    _this.tabRef = _react["default"].createRef();
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(TabItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          privateRegisterTab = _this$props.privateRegisterTab,
          name = _this$props.name,
          disabled = _this$props.disabled;

      if (!disabled) {
        setTimeout(function () {
          return privateRegisterTab({
            name: name,
            ref: _this2.tabRef.current
          });
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevName = _ref.name;
      var _this$props2 = this.props,
          name = _this$props2.name,
          privateUpdateTab = _this$props2.privateUpdateTab;

      if (name !== prevName) {
        privateUpdateTab({
          name: name,
          ref: this.tabRef.current
        }, prevName);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
          privateUnRegisterTab = _this$props3.privateUnRegisterTab,
          name = _this$props3.name;
      privateUnRegisterTab(name);
    }
  }, {
    key: "getTabIndex",
    value: function getTabIndex() {
      if (this.isSelected()) {
        return 0;
      }

      return -1;
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(e) {
      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          onSelect = _this$props4.onSelect,
          name = _this$props4.name;

      if (!disabled) {
        onSelect(e, name);
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected() {
      var _this$props5 = this.props,
          activeTabName = _this$props5.activeTabName,
          name = _this$props5.name;
      return activeTabName === name;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          label = _this$props6.label,
          style = _this$props6.style,
          className = _this$props6.className,
          title = _this$props6.title,
          id = _this$props6.id,
          ariaControls = _this$props6.ariaControls,
          fullWidth = _this$props6.fullWidth,
          disabled = _this$props6.disabled;
      var isActive = this.isSelected();
      return _react["default"].createElement(_container["default"], {
        className: className,
        fullWidth: fullWidth,
        isActive: isActive,
        style: style,
        title: title,
        role: "presentation"
      }, _react["default"].createElement(_button["default"], {
        role: "tab",
        "aria-selected": isActive,
        onClick: this.handleSelect,
        tabIndex: this.getTabIndex(),
        id: id,
        "aria-controls": ariaControls,
        ref: this.tabRef,
        isActive: isActive,
        disabled: disabled,
        fullWidth: fullWidth,
        "data-active": isActive
      }, _react["default"].createElement(_truncatedText["default"], null, label)));
    }
  }]);
  return TabItem;
}(_react.Component);
/** @category Layout */


function Tab(props) {
  return _react["default"].createElement(_context.Consumer, null, function (context) {
    return _react["default"].createElement(TabItem, (0, _extends2["default"])({}, props, context));
  });
}

Tab.propTypes = {
  /** The text displayed for the tab item. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),

  /** The name is used during tabset's onSelect
   * event to determine which tab was clicked. */
  name: _propTypes["default"].string,

  /** Displays tooltip text when the mouse moves over the element. */
  title: _propTypes["default"].string,

  /** Specifies whether this tab should be displayed in a disabled state.
   * Disabled tabs can't be clicked. This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** This ID is to be associated with the aria-labelledby attribute of the container
   * that show the content of this tab. */
  id: _propTypes["default"].string,

  /** This prop is associated with the id attribute of the container
   * that show the content of this tab. */
  ariaControls: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object
};
Tab.defaultProps = {
  label: null,
  name: undefined,
  title: undefined,
  disabled: false,
  id: undefined,
  ariaControls: undefined,
  className: undefined,
  style: undefined
};